import api from './api';

export const listDiscountCodes = () =>
  api.get('/admin/coupons/discounts').then(r => r.data.codes);

export const createDiscountCode = (fields) =>
  api.post('/admin/coupons/discounts', fields).then(r => r.data);

export const deactivateDiscountCode = (id) =>
  api.delete(`/admin/coupons/discounts/${id}`).then(r => r.data);

export const listTrialCodes = () =>
  api.get('/admin/coupons/trials').then(r => r.data.codes);

export const createTrialCode = (fields) =>
  api.post('/admin/coupons/trials', fields).then(r => r.data);

export const deactivateTrialCode = (id) =>
  api.delete(`/admin/coupons/trials/${id}`).then(r => r.data);
